/* eslint-disable */
import { BulkEmailJobStatus } from '../dto/bulk-email-job-status';

export interface HistoryRecipientListResponseDto {
  userName: string;
  customerId: string;
  status: BulkEmailJobStatus;
  failedCount: number;
  failedReason: string | null;
  latestStatusChangeOn: Date;
}

export const fixHistoryRecipientListResponseDtoFromJson = (dto?: HistoryRecipientListResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.latestStatusChangeOn = dto.latestStatusChangeOn && new Date(dto.latestStatusChangeOn);
};

export const fixHistoryRecipientListResponseDtoToJson = (dto?: HistoryRecipientListResponseDto | null): void => {
  if (!dto) {
    return;
  }
};
